/* =========================================================
   Sportsndeco.com — Moteur "AFFICHE DE COMBAT (VS)".
   Affiche d'événement : deux combattants face à face + VS + enjeu.
   API : SNCombatVS.render(data, opts) -> string SVG
     data : { event, date, venue, discipline, f1Name, f1Nick, f1Record,
              f2Name, f2Nick, f2Record, stake, rounds }
     opts : { palette }
   Auto-suffisant → re-render serveur direct pour l'impression.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 64;
  const PALETTES = {
    nuit:  { label:'Nuit',  bg:'#0B1B33', ink:'#ffffff', muted:'#8FA1B8', accent:'#FF6B2C', gold:'#E8B04B', line:'#24374f' },
    noir:  { label:'Noir',  bg:'#111418', ink:'#ffffff', muted:'#8A8F98', accent:'#FF6B2C', gold:'#E8B04B', line:'#2A2E35' },
    ring:  { label:'Ring',  bg:'#1A0E10', ink:'#ffffff', muted:'#B79097', accent:'#FF4D3D', gold:'#E8B04B', line:'#3A2427' },
    craie: { label:'Craie', bg:'#F5F2EB', ink:'#14243B', muted:'#7A8699', accent:'#FF6B2C', gold:'#B8862B', line:'#E1DBD0' },
  };
  const esc = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const nameSize = n => n.length > 13 ? 44 : n.length > 9 ? 54 : 64;

  function fighter(p, cx, yNick, yName, yRec, nick, name, rec) {
    const nm = (name || 'COMBATTANT').toUpperCase();
    return (nick ? `<text x="${cx}" y="${yNick}" font-size="18" font-weight="600" fill="${p.gold}" text-anchor="middle" letter-spacing="1.5">« ${esc(String(nick).toUpperCase())} »</text>` : '')
      + `<text x="${cx}" y="${yName}" font-size="${nameSize(nm)}" font-weight="800" fill="${p.ink}" text-anchor="middle" letter-spacing="-1.5">${esc(nm)}</text>`
      + (rec ? `<text x="${cx}" y="${yRec}" font-size="16" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="2">${esc(rec)}</text>` : '');
  }

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.nuit;
    const cx = PW / 2;
    const dateVenue = [data.date, data.venue].filter(v => String(v || '').trim()).map(v => String(v).toUpperCase()).join(' · ');

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
<rect x="20" y="20" width="${PW - 40}" height="${PH - 40}" fill="none" stroke="${p.line}" stroke-width="1.5" rx="3"/>
<text x="${cx}" y="130" font-size="16" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="5">${esc(String(data.event || 'FIGHT NIGHT').toUpperCase())}</text>
${ dateVenue ? `<text x="${cx}" y="162" font-size="14" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="3">${esc(dateVenue)}</text>` : '' }
${ data.discipline ? `<text x="${cx}" y="${dateVenue ? 190 : 162}" font-size="12.5" font-weight="600" fill="${p.gold}" text-anchor="middle" letter-spacing="4">${esc(String(data.discipline).toUpperCase())}</text>` : '' }
<line x1="${MX}" y1="230" x2="${PW - MX}" y2="230" stroke="${p.line}" stroke-width="1.5"/>
${ fighter(p, cx, 322, 386, 424, data.f1Nick, data.f1Name, data.f1Record) }
<text x="${cx}" y="590" font-size="112" font-weight="800" fill="${p.accent}" text-anchor="middle" letter-spacing="-2">VS</text>
<line x1="${MX + 140}" y1="536" x2="${MX + 220}" y2="536" stroke="${p.line}" stroke-width="1.5"/>
<line x1="${PW - MX - 220}" y1="536" x2="${PW - MX - 140}" y2="536" stroke="${p.line}" stroke-width="1.5"/>
${ fighter(p, cx, 700, 764, 802, data.f2Nick, data.f2Name, data.f2Record) }
<line x1="${MX}" y1="866" x2="${PW - MX}" y2="866" stroke="${p.line}" stroke-width="1.5"/>
${ data.stake ? `<text x="${cx}" y="916" font-size="20" font-weight="800" fill="${p.ink}" text-anchor="middle" letter-spacing="1">${esc(String(data.stake).toUpperCase())}</text>` : '' }
${ data.rounds ? `<text x="${cx}" y="${data.stake ? 946 : 920}" font-size="13" font-weight="600" fill="${p.accent}" text-anchor="middle" letter-spacing="3">${esc(String(data.rounds).toUpperCase())}</text>` : '' }
</svg>`;
  }

  window.SNCombatVS = { render, PALETTES };
})();
